// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
} */

.header-border {
  border-bottom: 1px solid #ddd;
}
/* File: Card.css */
.card {
  background: linear-gradient(60deg, rgba(1, 1, 2, 0.8), rgba(35, 41, 49, 0.6)), transparent; /* Dark gradient background */
  color: white;
  padding: 16px;
  border-radius: 8px;
  width: 300px;
  height: 240px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-family: "Poppins", sans-serif;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px); /* Apply blur effect */
  position: relative;
  overflow: hidden;
}

.profile {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.profile-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.profile-info {
  margin-left: 12px;
}

.name {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.location {
  font-size: 14px;
  color: #9ca3af;
  margin: 0;
}

.account-details {
  display: flex;
  flex-direction: column;
}

.detail {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.label {
  font-size: 14px;
  color: #9ca3af;
}

.value {
  font-size: 14px;
}

.payout {
  color: #38bdf8;
}
.card-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}
.card-main2 {
  margin-top: 20px;
  margin-left: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* File: ScrollingText.css */
.scrolling-text-container {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  background-color: #131416;
  padding: 20px;
  border-radius: 8px;
  color: white;
  font-family: "Poppins", sans-serif;
  position: relative;
}

.scrolling-text {
  display: inline-block;
  white-space: nowrap;
  animation: scrollText 20s linear infinite;
}

.scrolling-text span {
  display: inline-flex;
  align-items: center;
  margin-right: 50px; /* Space between each text */
}

.star-ico {
  color: #767a81;
}

@keyframes scrollText {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* File: LogoCarousel.css */
.logo-carousel-container {
  display: flex;
  justify-content: space-between; /* Space logos evenly */
  align-items: center;
  padding: 20px;
  background-color: #f8f9fa; /* Light background color */
  border: 2px solid #ddd; /* Add border around the entire logo section */
  border-radius: 8px;
  overflow: hidden;
}

.logo-item {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px; /* Space between logos */
}

.logo-image {
  max-width: 100%; /* Make images responsive */
  max-height: 60px; /* Set a max height for logos */
  object-fit: contain; /* Maintain aspect ratio */
}

.phase-container {
  max-width: 900px;
  margin: auto;
  padding: 20px;
  border-radius: 8px;
}

.phase-btn-group {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.phase-btn {
  padding: 10px 30px;
  color: white;
  border-radius: 10px;
  letter-spacing: 3px;
  border: 1px solid white;
  cursor: pointer;
  background-color: transparent;
}

.phase-btn.active {
  background-color: #a58d66;
  color: white;
}

.phase-card-group {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;  
}

.phase-card {
  border: 1px solid #444;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 8px;
  color: white;
  flex: 0 0 48%;
  box-sizing: border-box;
}

.phase-card-header {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}

.phase-card-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #c1a96c;
}

.phase-card-item:last-child {
  border-bottom: none;
}

@media (max-width: 768px) {
  .phase-card {
    flex: 0 0 100%;
  }
}

.phase-toggle-container {
  max-width: 1200px;
  margin: auto;
  padding: 20px;
}

.phase-toggle-btn-group {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  padding: 8px 10px;
  background: linear-gradient(to right, #86704b 0%, #bea67d 100%);
  border-radius: 50px;
  border: 2px solid #ffffff
}

.phase-toggle-btn {
  padding: 10px 20px;
  font-size: 18px;
  color: white;
  border: none;
  cursor: pointer;
  background-color: transparent;
  border-radius: 50px;
  
}

.phase-toggle-btn.active {
  background-color: rgba(28, 24, 24, 0.674);;
  color: white;
}

.phase-toggle-card-group {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.phase-toggle-card {
  border: 1px solid #b79f76;
  margin-bottom: 20px;
  border-radius: 8px;
  flex: 0 0 22%;
  box-sizing: border-box;
  text-align: center;
}
/* Media query for mobile screens */
@media (max-width: 768px) {
  .phase-toggle-card {
    flex: 0 0 100%; /* Full width on mobile */
  }
}
.phase-toggle-card-header {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  background-color: #b79f76;
  padding: 10px;
  border-radius: 8px 8px 0 0;
}

.phase-toggle-card-item {
  text-align: center;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #b79f76;
}

.phase-toggle-card-item span {
  display: block;
}

.phase-toggle-card-item:last-child {
  border-bottom: none;
}

.phase-toggle-start-btn {
  background-color: black;
  color: white;
  border: 2px solid white;
  padding: 10px 30px;
  margin-top: 20px;
  cursor: pointer;
  border-radius: 8px;
}
.home-hero {
  background: transparent; /* Fallback for older browsers */
  background: radial-gradient(circle at top left, rgba(193, 169, 111, 0.2), transparent 30%), radial-gradient(circle at bottom, rgba(193, 169, 111, 0.2), transparent 25%),
    radial-gradient(circle at top right, rgba(193, 169, 111, 0.2), transparent 25%), transparent; /* Black background as base */
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 1;
}

.hero-man {
  position: absolute;
  top: 65%;
  right: 50%;
  z-index: -1;
  width: 70%;
}

.slider-label {
  margin-bottom: 20px;
  font-size: 18px;
}

.rc-slider-mark-text {
  color: #e0d4b1; /* Adjust mark text color */
  font-size: 14px;
  white-space: nowrap; /* Ensure text doesn't wrap */
}

.rc-slider-mark-text-active {
  color: #ffff !important; /* Active mark text color */
}

.rc-slider-dot-active {
  border-color: #aa926b !important;
}
.rc-slider-dot {
  top: 1%;
}
.rc-slider-handle {
  border: 2px solid #aa926b !important;
}

.rc-slider-track {
  background-color: #aa926b !important;
}

.rc-slider-rail {
  background-color: #231d23 !important;
}
.currency-btn {
  background: "#0000";
  color: "white";
  border: "2px solid #C1A96F";
  border-radius: "10px";
  padding: "8px 17px";
}

table {
  width: 100%;
  border-collapse: collapse;
  background-color: #242424; /* Dark background */
  color: #fff; /* Light text color */
  border-radius: 20px;
}

th {
  padding: 15px 10px;
  text-align: center;
  font-weight: 400;
}

td {
  padding: 15px 10px;
  text-align: center;

  border-bottom: 1px solid #ffffff2d; /* Border color */
}

tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.1); /* Highlight on hover */
}

.phase1-card {
  background-color: #242424; /* Dark background */
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  border: 1px solid #747373;
  margin-left: 2rem;
}

.phase1-card {
  background-color: #242424; /* Dark background */
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  border: 1px solid #747373;
  margin-left: 2rem;
}

.btn-size{
  font-size: 1rem !important;
}

@media (max-width: 575px) {
  .phase1-card {
    margin-left: 0rem;
    margin-top: 1rem;
  }
  
  #account-sizes{
    margin-left: 0rem;
  }
  
  .btn-only{
    margin-bottom: 2rem;
  }
}

/* Position and sizing of burger button */
.bm-burger-button {
  position: fixed;
  width: 30px;
  height: 25px;
  right: 36px;
  top: 20px;
}

/* Color/shape of burger icon bars */
.bm-burger-bars {
  background: #ffffff;
}

/* Color/shape of burger icon bars on hover*/
.bm-burger-bars-hover {
  background: #c1a96c;
}

/* Position and sizing of clickable cross button */
.bm-cross-button {
  height: 24px;
  width: 24px;
}

/* Color/shape of close button cross */
.bm-cross {
  background: #bdc3c7;
}

/*
Sidebar wrapper styles
Note: Beware of modifying this element as it can break the animations - you should not need to touch it in most cases
*/
.bm-menu-wrap {
  position: fixed;
  height: 47rem !important;
}

/* General sidebar styles */
.bm-menu {
  background: #000000;
  padding: 2.5em 1.5em 0;
  font-size: 1.15em;
}

/* Morph shape necessary with bubble or elastic */
.bm-morph-shape {
  fill: #373a47;
}

/* Wrapper for item list */
.bm-item-list {
  color: #ffffff;
  padding: 0.8em;
}

/* Individual item */
.bm-item {
  display: inline-block;
  margin-bottom: 2rem;
}

/* Styling of overlay */
.bm-overlay {
  background: rgba(0, 0, 0, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;GAYG;;AAEH;EACE,6BAA6B;AAC/B;AACA,mBAAmB;AACnB;EACE,0FAA0F,EAAE,6BAA6B;EACzH,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,kCAAkC;EAClC,mCAA2B;UAA3B,2BAA2B,EAAE,sBAAsB;EACnD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,4BAA4B;AAC5B;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B,EAAE,uBAAuB;EACvD,mBAAmB;EACnB,aAAa;EACb,yBAAyB,EAAE,2BAA2B;EACtD,sBAAsB,EAAE,8CAA8C;EACtE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;EACE,eAAe,EAAE,2BAA2B;EAC5C,gBAAgB,EAAE,+BAA+B;EACjD,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,+DAA+D;EAC/D,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;;AAErB;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA,mCAAmC;AACnC;EACE;IACE,cAAc,EAAE,yBAAyB;EAC3C;AACF;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,uBAAuB,EAAE,gCAAgC;EACzD;gGAC8F,EAAE,6BAA6B;EAC7H,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,2BAA2B;EAC3C,eAAe;EACf,mBAAmB,EAAE,6BAA6B;AACpD;;AAEA;EACE,uBAAuB,EAAE,2BAA2B;AACtD;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,OAAO;AACT;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB,EAAE,oBAAoB;EAC/C,WAAW,EAAE,qBAAqB;EAClC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;;EAElB,kCAAkC,EAAE,iBAAiB;AACvD;;AAEA;EACE,0CAA0C,EAAE,uBAAuB;AACrE;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;AACrB;;AAEA;;;CAGC;AACD;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;AAChC","sourcesContent":["/* body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n} */\n\n.header-border {\n  border-bottom: 1px solid #ddd;\n}\n/* File: Card.css */\n.card {\n  background: linear-gradient(60deg, rgba(1, 1, 2, 0.8), rgba(35, 41, 49, 0.6)), transparent; /* Dark gradient background */\n  color: white;\n  padding: 16px;\n  border-radius: 8px;\n  width: 300px;\n  height: 240px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  font-family: \"Poppins\", sans-serif;\n  backdrop-filter: blur(10px); /* Apply blur effect */\n  position: relative;\n  overflow: hidden;\n}\n\n.profile {\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.profile-image {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n}\n\n.profile-info {\n  margin-left: 12px;\n}\n\n.name {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 0;\n}\n\n.location {\n  font-size: 14px;\n  color: #9ca3af;\n  margin: 0;\n}\n\n.account-details {\n  display: flex;\n  flex-direction: column;\n}\n\n.detail {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.label {\n  font-size: 14px;\n  color: #9ca3af;\n}\n\n.value {\n  font-size: 14px;\n}\n\n.payout {\n  color: #38bdf8;\n}\n.card-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n.card-main2 {\n  margin-top: 20px;\n  margin-left: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n/* File: ScrollingText.css */\n.scrolling-text-container {\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  background-color: #131416;\n  padding: 20px;\n  border-radius: 8px;\n  color: white;\n  font-family: \"Poppins\", sans-serif;\n  position: relative;\n}\n\n.scrolling-text {\n  display: inline-block;\n  white-space: nowrap;\n  animation: scrollText 20s linear infinite;\n}\n\n.scrolling-text span {\n  display: inline-flex;\n  align-items: center;\n  margin-right: 50px; /* Space between each text */\n}\n\n.star-ico {\n  color: #767a81;\n}\n\n@keyframes scrollText {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n/* File: LogoCarousel.css */\n.logo-carousel-container {\n  display: flex;\n  justify-content: space-between; /* Space logos evenly */\n  align-items: center;\n  padding: 20px;\n  background-color: #f8f9fa; /* Light background color */\n  border: 2px solid #ddd; /* Add border around the entire logo section */\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.logo-item {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 10px; /* Space between logos */\n}\n\n.logo-image {\n  max-width: 100%; /* Make images responsive */\n  max-height: 60px; /* Set a max height for logos */\n  object-fit: contain; /* Maintain aspect ratio */\n}\n\n.phase-container {\n  max-width: 900px;\n  margin: auto;\n  padding: 20px;\n  border-radius: 8px;\n}\n\n.phase-btn-group {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.phase-btn {\n  padding: 10px 30px;\n  color: white;\n  border-radius: 10px;\n  letter-spacing: 3px;\n  border: 1px solid white;\n  cursor: pointer;\n  background-color: transparent;\n}\n\n.phase-btn.active {\n  background-color: #a58d66;\n  color: white;\n}\n\n.phase-card-group {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;  \n}\n\n.phase-card {\n  border: 1px solid #444;\n  padding: 20px;\n  margin-bottom: 20px;\n  border-radius: 8px;\n  color: white;\n  flex: 0 0 48%;\n  box-sizing: border-box;\n}\n\n.phase-card-header {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.phase-card-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #c1a96c;\n}\n\n.phase-card-item:last-child {\n  border-bottom: none;\n}\n\n@media (max-width: 768px) {\n  .phase-card {\n    flex: 0 0 100%;\n  }\n}\n\n.phase-toggle-container {\n  max-width: 1200px;\n  margin: auto;\n  padding: 20px;\n}\n\n.phase-toggle-btn-group {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 30px;\n  padding: 8px 10px;\n  background: linear-gradient(to right, #86704b 0%, #bea67d 100%);\n  border-radius: 50px;\n  border: 2px solid #ffffff\n}\n\n.phase-toggle-btn {\n  padding: 10px 20px;\n  font-size: 18px;\n  color: white;\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n  border-radius: 50px;\n  \n}\n\n.phase-toggle-btn.active {\n  background-color: rgba(28, 24, 24, 0.674);;\n  color: white;\n}\n\n.phase-toggle-card-group {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.phase-toggle-card {\n  border: 1px solid #b79f76;\n  margin-bottom: 20px;\n  border-radius: 8px;\n  flex: 0 0 22%;\n  box-sizing: border-box;\n  text-align: center;\n}\n/* Media query for mobile screens */\n@media (max-width: 768px) {\n  .phase-toggle-card {\n    flex: 0 0 100%; /* Full width on mobile */\n  }\n}\n.phase-toggle-card-header {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  background-color: #b79f76;\n  padding: 10px;\n  border-radius: 8px 8px 0 0;\n}\n\n.phase-toggle-card-item {\n  text-align: center;\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #b79f76;\n}\n\n.phase-toggle-card-item span {\n  display: block;\n}\n\n.phase-toggle-card-item:last-child {\n  border-bottom: none;\n}\n\n.phase-toggle-start-btn {\n  background-color: black;\n  color: white;\n  border: 2px solid white;\n  padding: 10px 30px;\n  margin-top: 20px;\n  cursor: pointer;\n  border-radius: 8px;\n}\n.home-hero {\n  background: transparent; /* Fallback for older browsers */\n  background: radial-gradient(circle at top left, rgba(193, 169, 111, 0.2), transparent 30%), radial-gradient(circle at bottom, rgba(193, 169, 111, 0.2), transparent 25%),\n    radial-gradient(circle at top right, rgba(193, 169, 111, 0.2), transparent 25%), transparent; /* Black background as base */\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  z-index: 1;\n}\n\n.hero-man {\n  position: absolute;\n  top: 65%;\n  right: 50%;\n  z-index: -1;\n  width: 70%;\n}\n\n.slider-label {\n  margin-bottom: 20px;\n  font-size: 18px;\n}\n\n.rc-slider-mark-text {\n  color: #e0d4b1; /* Adjust mark text color */\n  font-size: 14px;\n  white-space: nowrap; /* Ensure text doesn't wrap */\n}\n\n.rc-slider-mark-text-active {\n  color: #ffff !important; /* Active mark text color */\n}\n\n.rc-slider-dot-active {\n  border-color: #aa926b !important;\n}\n.rc-slider-dot {\n  top: 1%;\n}\n.rc-slider-handle {\n  border: 2px solid #aa926b !important;\n}\n\n.rc-slider-track {\n  background-color: #aa926b !important;\n}\n\n.rc-slider-rail {\n  background-color: #231d23 !important;\n}\n.currency-btn {\n  background: \"#0000\";\n  color: \"white\";\n  border: \"2px solid #C1A96F\";\n  border-radius: \"10px\";\n  padding: \"8px 17px\";\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #242424; /* Dark background */\n  color: #fff; /* Light text color */\n  border-radius: 20px;\n}\n\nth {\n  padding: 15px 10px;\n  text-align: center;\n  font-weight: 400;\n}\n\ntd {\n  padding: 15px 10px;\n  text-align: center;\n\n  border-bottom: 1px solid #ffffff2d; /* Border color */\n}\n\ntbody tr:hover {\n  background-color: rgba(255, 255, 255, 0.1); /* Highlight on hover */\n}\n\n.phase1-card {\n  background-color: #242424; /* Dark background */\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 20px;\n  border: 1px solid #747373;\n  margin-left: 2rem;\n}\n\n.phase1-card {\n  background-color: #242424; /* Dark background */\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 20px;\n  border: 1px solid #747373;\n  margin-left: 2rem;\n}\n\n.btn-size{\n  font-size: 1rem !important;\n}\n\n@media (max-width: 575px) {\n  .phase1-card {\n    margin-left: 0rem;\n    margin-top: 1rem;\n  }\n  \n  #account-sizes{\n    margin-left: 0rem;\n  }\n  \n  .btn-only{\n    margin-bottom: 2rem;\n  }\n}\n\n/* Position and sizing of burger button */\n.bm-burger-button {\n  position: fixed;\n  width: 30px;\n  height: 25px;\n  right: 36px;\n  top: 20px;\n}\n\n/* Color/shape of burger icon bars */\n.bm-burger-bars {\n  background: #ffffff;\n}\n\n/* Color/shape of burger icon bars on hover*/\n.bm-burger-bars-hover {\n  background: #c1a96c;\n}\n\n/* Position and sizing of clickable cross button */\n.bm-cross-button {\n  height: 24px;\n  width: 24px;\n}\n\n/* Color/shape of close button cross */\n.bm-cross {\n  background: #bdc3c7;\n}\n\n/*\nSidebar wrapper styles\nNote: Beware of modifying this element as it can break the animations - you should not need to touch it in most cases\n*/\n.bm-menu-wrap {\n  position: fixed;\n  height: 47rem !important;\n}\n\n/* General sidebar styles */\n.bm-menu {\n  background: #000000;\n  padding: 2.5em 1.5em 0;\n  font-size: 1.15em;\n}\n\n/* Morph shape necessary with bubble or elastic */\n.bm-morph-shape {\n  fill: #373a47;\n}\n\n/* Wrapper for item list */\n.bm-item-list {\n  color: #ffffff;\n  padding: 0.8em;\n}\n\n/* Individual item */\n.bm-item {\n  display: inline-block;\n  margin-bottom: 2rem;\n}\n\n/* Styling of overlay */\n.bm-overlay {\n  background: rgba(0, 0, 0, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
